import React, { useContext } from 'react';

// DEPENDENCIES
import clsx from 'clsx';
import toString from 'lodash/toString';

// CONTEXT
import { ListContext } from 'helpers/getListData';

// GLOBAL FUNCTIONS
import Sprite from 'core/tools/Sprite';

// CORE COMPONENTS
import NumberFormat from 'core/tools/NumberFormat';
import Tooltip from 'core/tools/Tooltip';

// STYLES
import styles from './comparisonCell.module.scss';

// MAIN COMPONENT
const ComparisonCell = ({
  column: {
    Header, //
    comparison: {
      comparedToKey, //
      tooltip = [`DSL ${Header}`, `Accounting ${Header}`],
      highlight = true
    } = {},
    numberFormat
  },
  placeholder,
  row: {
    original: row = [] //
  },
  value
}) => {
  const valueArray = [value, comparedToKey ? row[comparedToKey] : value];

  const {
    preferences: { filters: { auditStatus } = {} }
  } = useContext(ListContext) || {};

  return toString(value).trim() ? (
    <div className={clsx('d-flex', styles.overflow)}>
      <div className={clsx(styles.overflow, numberFormat && 'text-end')}>
        {valueArray.map(
          (v, i) =>
            toString(v).trim() && (
              <Tooltip
                key={i}
                tip={tooltip[i]}
                wrapperClassName={clsx('d-flex align-items-center', styles.overflow, i !== 0 && 'mt-1')}
              >
                {highlight && (auditStatus === 'matches' || auditStatus === 'nomatches') && valueArray?.[0] === valueArray?.[1] ? (
                  <Sprite use="success" className="text-success" />
                ) : null}
                {highlight && auditStatus === 'nomatches' && valueArray?.[0] !== valueArray?.[1] ? (
                  <Sprite use="warning" className="text-danger" />
                ) : null}
                <div key={i} className="p-1 text-truncate">
                  {numberFormat ? <NumberFormat displayType="text" value={v} format={numberFormat} /> : v}
                </div>
              </Tooltip>
            )
        )}
      </div>
    </div>
  ) : (
    placeholder
  );
};

// EXPORT
export default ComparisonCell;
